import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ToolTip } from '@custom-components';
import LocaleLink from '../../../components/LocaleLink';
import { PortalButton } from '../../BuildingBlocks/PortalButton/PortalButton';
import { UserCtx } from '../../../contexts/UserCtx';

import {
  StyledInfoContainer,
  SubBar,
  LeftSubBarContainer,
  RightSubBarContainer,
  ChildrenContainer,
  LinkButton
} from './InfoContainer.styles';
import { ReactChildrenPropType } from '../../../lib/commonPropTypes';

class InfoContainer extends Component {
  getSubBarContents = (item, index) => {
    const { type, props } = item;
    if (type === 'tabBarButton') {
      const key = `button${index}`;
      return <PortalButton key={key} {...props} />;
    }
    if (type === 'label') {
      const key = `label${index}`;
      return <div key={key}>{props.label}</div>;
    }
    if (type === 'button') {
      const key = `button${index}`;
      return (
        <PortalButton key={key} {...props}>
          {props.children}
        </PortalButton>
      );
    }
    if (type === 'linkButton') {
      const key = `button${index}`;
      const { label, params, route, reqPermission } = props;
      let { title, disabled } = props;

      // If reqPermission is specified, check the user has the permission, and disable
      // the control/override the title if they are
      if (reqPermission !== undefined) {
        const userCtx = this.context;
        const denyReason = userCtx.denyReason(reqPermission);
        if (denyReason !== undefined) {
          disabled = true;
          title = denyReason;
        }
      }

      if (disabled)
        return (
          <LinkButton title={title} disabled>
            {label}
          </LinkButton>
        );
      return (
        <LocaleLink key={key} route={route} params={params} passHref>
          <LinkButton title={title}>{label}</LinkButton>
        </LocaleLink>
      );
    }
    if (type === 'toolTip') {
      const key = `button${index}`;
      return <ToolTip key={key} {...props} />;
    }
    const key = `search${index}`;
    return <div key={key}>{props}</div>;
  };

  render() {
    const { leftSubBarContents, rightSubBarContents, children, className, noPadding, editing } = this.props;
    return (
      <StyledInfoContainer className={className} editing={editing}>
        <SubBar>
          <LeftSubBarContainer>{leftSubBarContents.map(this.getSubBarContents)}</LeftSubBarContainer>
          <RightSubBarContainer>{rightSubBarContents.map(this.getSubBarContents)}</RightSubBarContainer>
        </SubBar>
        <ChildrenContainer noPadding={noPadding}>{children}</ChildrenContainer>
      </StyledInfoContainer>
    );
  }
}

InfoContainer.contextType = UserCtx;

InfoContainer.propTypes = {
  leftSubBarContents: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.oneOf(['tabBarButton', 'searchBar', 'label', 'button', 'linkButton', 'toolTip']),
      props: PropTypes.shape({})
    })
  ),

  rightSubBarContents: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.oneOf(['tabBarButton', 'searchBar', 'label', 'button', 'linkButton', 'toolTip']),
      props: PropTypes.shape({})
    })
  ),
  className: PropTypes.string,

  noPadding: PropTypes.bool,

  editing: PropTypes.bool,

  disabled: PropTypes.bool,

  title: PropTypes.string,

  children: ReactChildrenPropType
};

InfoContainer.defaultProps = {
  className: '',
  leftSubBarContents: [],
  rightSubBarContents: [],
  noPadding: false,
  editing: false,
  disabled: false,
  title: undefined,
  children: []
};

export default InfoContainer;
